<template>
  <div>

    <loader v-if="loader"/>

    <b-row>
      <b-col class="text-muted">
        <b-row>
          <b-col
            :xl="input.columns"
            md="4"
            class="mb-4"
            v-for="(input, index) in mainInputs"
            :key="`${index}${input.name}`">
            <b-input-group class="flex-column">
              <label class="d-block" :for="input.id">{{ input.label }}</label>
              <div class="position-relative">
                <b-form-input
                class="rounded"
                v-if="input.type === 'text'"
                v-model="filterObject[input.name]"
                :placeholder="input.placeholder"
                :name="input.name"
                :id="input.id"
                @input="value => {debounceFilter(input.name, value)}"
                autocomplete="off"
              />
              </div>


              <multiselect
                v-if="input.type === 'select' && !input.group"
                v-model="filterObject[input.name]"
                :multiple="input.multiple"
                :id="input.name"
                label="label"
                track-by="value"
                :placeholder="input.placeholder"
                :options="input.options"
                :searchable="input.searchable"
                :allow-empty="input.allow_empty"
                :close-on-select="!input.multiple"
                @select="value => {debounceFilter(input.name, value, input.multiple)}"
                @remove="value => {debounceFilter(input.name, value, input.multiple, true)}"
                @search-change="query => {debounceGetSelectOptions(input.options_url, input.name, input.filter_field, query)}"
                select-label=""
                selected-label=""
                deselect-label="X ">
                <template slot="noResult">
                  {{$t('global.no_results')}}
                </template>
              </multiselect>

              <group-select
                  :show-label="false"
                  v-if="input.type === 'select' && input.group"
                  :input="input"
                  @select="filter"
                  @remove="filter"
                  :group-select="input.groupSelect"
              />

            </b-input-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-button
                v-if="extendButton"
                class="px-4  mb-2"
                variant="outline-primary"
                @click="extend = !extend; "
                :disabled="disableInput('button')"
            >{{ !extend ? 'Show advanced filters' : 'Hide advanced filters' }}
            </b-button>

          </b-col>
        </b-row>
        <b-row v-if="extend">

          <b-col>

            <b-row>
              <b-col class="mb-4"
                     :md="inputsWidth"
                     v-for="(input, index) in inputsText"
                     :key="`${index}${input.name}`">
                <b-input-group class=" flex-column">

                  <label
                    class="d-block"
                    v-if="input.label"
                    :for="input.id"
                  >{{ input.label }}</label>

                  <b-form-input
                    class="rounded"
                    v-model="filterObject[input.name]"
                    :placeholder="input.placeholder"
                    :disabled="disableInput(input.name)"
                    :name="input.name"
                    :id="input.id"
                    autocomplete="off"
                    @input="value => {debounceFilter(input.name, value)}"
                  />

                </b-input-group>

              </b-col>

              <b-col class="mb-4"
                     :md="inputsWidth"
                     v-for="(input, index) in priceRanges"
                     :key="`${index}${input.name}`">
                <label
                  class="d-block"
                  v-if="input.label"
                  :for="input.id"
                >{{ input.label }}</label>
                <b-row>
                  <b-col
                    v-for="(option, index) in input.options"
                    :key="`${index}${input.name}`"
                  >
                    <b-input-group class="flex-column">
                      <money v-model="filterObject.range[option.name]"
                             :disabled="disableInput(option.name)"
                             @input="value => {debounceFilter(`${input.name} ${option.name}`, value, false, false, true)}"
                             :placeholder="option.placeholder"
                             v-bind="money"
                             class="rounded">
                      </money>
                    </b-input-group>
                  </b-col>
                </b-row>

              </b-col>

              <b-col
                :md="inputsWidth"
                class=" flex-column mb-4"
                v-for="(input, index) in selects"
                :key="`${index}${input.name}`"
                v-if="selectOptions[input.name]"
              >

                <label
                  class="d-block"
                  v-if="input.label"
                  :for="input.id">{{ input.label }}</label>

                <multiselect
                  v-model="filterObject[input.name]"
                  :multiple="input.multiple"
                  :id="input.name"
                  label="label"
                  track-by="value"
                  :placeholder="input.placeholder"
                  :options="selectOptions[input.name]"
                  :searchable="input.searchable"
                  :allow-empty="input.allow_empty"
                  :close-on-select="!input.multiple"
                  :disabled="disableInput(input.name)"
                  @select="value => {filter(input.name, value, input.multiple)}"
                  @remove="value => {filter(input.name, value, input.multiple, true)}"
                  @search-change="query => {debounceGetSelectOptions(input.options_url, input.name, input.filter_field, query)}"
                  select-label=""
                  selected-label=""
                  deselect-label="X ">
                  <template slot="noResult">
                    {{$t('global.no_results')}}
                  </template>
                </multiselect>

              </b-col>

              <b-col
                :md="inputsWidth"
                class=" flex-column mb-4"
                v-for="(input, index) in groupSelects"
                :key="`${index}${input.name}`"
              >
                <group-select
                  :input="input"
                  @select="filter"
                  @remove="filter"
                  :group-select="input.groupSelect"
                />
              </b-col>

              <b-col
                :md="inputsWidth"
                class=" flex-column mb-4"
                v-for="(input, index) in datepickers"
                :key="`${index}${input.name}`"
              >

                <label
                  class="d-block"
                  v-if="input.label"
                >{{ input.label }}</label>


                <DatePickerInput
                    v-model="filterObject[input.name]"
                    :mode="input.mode"
                    @input="value => {normalizeDate(input.name, value)}"
                    :is-range="input.isRange"
                />

              </b-col>

              <b-col
                :md="inputsWidth"
                class=" flex-column d-flex justify-content-end mb-4"
                v-for="(input, index) in checkboxes"
                :key="`${index}${input.name}`"
              >
                <b-form-checkbox
                  v-model="filterObject[input.name]"
                  :disabled="disableInput(input.name)"
                  :value="input.value"
                  @input="value => {filter(input.name, value, input.multiple)}"
                > {{input.label}}
                </b-form-checkbox>
              </b-col>

            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import {filter, forEach, isEmpty, isObject, pull, debounce, assign} from 'lodash';
  import {Money} from 'v-money'
  import DatePickerInput from "../forms/fields/datePickerInput";

  export default {
    props: {
      loading: {
        type: Boolean,
        default: false
      },
      inputs: {
        type: Array,
        required: true
      },
      limit: {
        type: Number,
        default: 10
      },
      extendButton: {
        type: Boolean,
        default: false
      },
      extended: {
        type: Boolean
      },
      globalFilter: {
        type: String,
        default: ''
      },
      inputsWidth: {
        type: Number,
        default: 4
      },
      filters: {
        type: Object,
        default: () => ({
          range: {
            from: '',
            to: ''
          }
        })
      }
    },
    data() {
      return {
        loader: false,
        filterObject: {
          range: {
            from: '',
            to: ''
          }
        },
        money: {
          decimal: '.',
          thousands: ',',
          prefix: '',
          suffix: '',
          precision: 2,
          masked: false
        },
        filterObjectMutated: {},
        selectOptions: {},
        extend: false,
        groupMultiselects: {},
        selectsReady: false,
        debounceGetSelectOptions: () => {
        }
      }
    },
    components: {DatePickerInput, Money},
    mounted() {
      this.filterObject = this.filters;
      this.$forceUpdate();
      this.loader = this.loading;
      this.extend = this.extended;
      this.debounceFilter = debounce(this.filter, 500);
      this.debounceGetSelectOptions = debounce(this.getSelectOptions, 500);
    },
    computed: {
      mainInputs() {
        return filter(this.inputs, input => input.main);
      },
      secondaryInputs() {
        return filter(this.inputs, input => !input.main)
      },
      inputsText() {
        return filter(this.secondaryInputs, input => input.type === 'text');
      },
      checkboxes() {
        return filter(this.secondaryInputs, input => input.type === 'checkbox');
      },
      priceRanges() {
        return filter(this.secondaryInputs, input => input.type === 'price-range');
      },
      selects() {
        let selects = filter(this.secondaryInputs, input => input.type === 'select' && !input.group);

        forEach(selects, select => {
          if (!!select.options_url) {
            this.getSelectOptions(select.options_url, select.name)
          } else {
            this.selectOptions[select.name] = select.options;
          }
        });
        return selects
      },
      groupSelects() {
        return filter(this.secondaryInputs, input => input.type === 'select' && input.group);
      },
      datepickers() {
        return filter(this.secondaryInputs, input => input.type === 'date');
      }
    },
    methods: {
      // clearInput (e, object, field) {
      //   console.log(e)
      //   const input = e.target.offsetParent.parentElement.querySelector('input');
      //
      //   if (!!input.value) {
      //     object[field] = '';
      // this.debounceFilter(name, '')
      // }
      // },
      disableInput(field) {
        if (this.globalFilter && this.filterObject[this.globalFilter] && this.filterObject[this.globalFilter].length > 0) {
          this.extend = false;
          return field !== this.globalFilter;
        } else {
          return false
        }
      },

      filter(field, value, multiple = false, remove = false, range = false) {
        if (range) {
          value = value * 100;
          field = field.split(' ');
          let range = field[1];
          field = field[0];
          if (!this.filterObject.range.from && !this.filterObject.range.to) {
            value = ''
          } else if (range === 'from') {
            if (!!this.filterObject.range.to) {
              if (parseInt(value) > parseInt(this.filterObject.range.to * 100)) {
                value = `${this.filterObject.range.to * 100}-${value}`
              } else {
                value = `${value}-${this.filterObject.range.to * 100}`
              }
            } else {
              value = `${value}-`
            }
          } else if (range === 'to') {
            if (!!this.filterObject.range.from) {
              if (parseInt(value) < parseInt(this.filterObject.range.from * 100) && parseInt(value) !== 0) {
                value = `${value}-${this.filterObject.range.from * 100}`
              } else if (parseInt(value) === 0) {
                value = `${this.filterObject.range.from * 100}-`
              } else {
                value = `${this.filterObject.range.from * 100}-${value}`
              }
            } else {
              value = `-${value}`
            }
          }
          value = value === '-' ? '' : value
        }

        if (isObject(field)) {
          value = field.value;
          multiple = field.multiple || false;
          remove = field.remove || false;
          field = field.field;
        }

        if (isObject(value)) {
          if (Array.isArray(value)) {
            value = value.map(item => {
              return item.value
            })
          } else if (value.hasOwnProperty('value')) {
            value = value.value;
          }
        }
        this.emitParams(field, value, multiple, remove)

      },

      emitParams(field, value, multiple, remove) {
        let params = {};
        if (field === this.globalFilter && value !== '') {
          params[field] = value;
          this.filterObject = assign({}, params);
          this.filterObjectMutated = assign({}, params);
        } else {
          if (multiple) {
            if (!this.filterObjectMutated[field]) {
              this.filterObjectMutated[field] = []
            }
            if (remove) {
              if(Array.isArray(value))
              for (let item of value) {
                this.filterObjectMutated[field] = _.filter(this.filterObjectMutated[field], (currentObject) => {
                  return currentObject.value !== item.value
                })
              } else {
                pull(this.filterObjectMutated[field], value);
              }

              if (isEmpty(this.filterObjectMutated[field])) {
                delete this.filterObjectMutated[field];
              }
            } else {
              if (Array.isArray(value)) {
                for (let item of value) {
                  this.filterObjectMutated[field].push(item);
                }
              } else {
                this.filterObjectMutated[field].push(value);
              }
            }
          } else {
            if (value === '' || remove) {
              delete this.filterObject[field];
              delete this.filterObjectMutated[field];
            } else {
              this.filterObjectMutated[field] = value;
            }
          }
          params = this.filterObjectMutated;
        }

        this.$emit('filter', params)
      },

      getSelectOptions(url, name, field = null, value = null) {
        const params = {filter: {}};
        if (value) {
          params.filter[field] = value
        }
        try {
          this.loader = true;
          if (url === 'countries') {
            this.getCountries(url, {params}).then(({data}) => {
              if (data && data.items) {
                this.$set(this.selectOptions, name, data.items.map(option => {
                  if (option.title) {
                    return {
                      label: option.title,
                      value: option.title
                    }
                  }
                }))
              }
            })
          } else {
            this.getData(url, {params}).then(({data}) => {
              if (data && data.items) {
                this.selectOptions[name] = data.items.map(option => {
                  if (option.name && option.id) {
                    return {
                      label: option.name,
                      value: option.id
                    }
                  } else if (option.slug && option.title) {
                    return {
                      label: option.title,
                      value: option.slug
                    }
                  } else if (option.slug && !option.title) {
                    return {
                      label: option.slug,
                      value: option.slug
                    }
                  } else if (option.title) {
                    return {
                      label: option.title,
                      value: option.title
                    }
                  } else if (option.key) {
                    return {
                      label: option.key,
                      value: option.id
                    }
                  }
                });
                this.$forceUpdate();
              }
            })
          }

        } catch (e) {
          console.log(e)
        } finally {
          this.loader = false;
        }
      },
      normalizeDate(field, value) {
        if (value instanceof Date) {
          value = this.formatDate(value, 'L');
          this.filter(field, value)
        } else if (!value) {
          this.filter(field, '');
        } else if (isObject(value)) {
          switch (field) {
            case 'userplanrelationships.created_at':
              this.filter(field, `${this.formatDate(value.start, 'L')}-${this.formatDate(value.end, 'L')}`);
              break;

            case 'userplanrelationships.subscription_end_date':
              this.filter(field, `${this.formatDate(value.start, 'L')}-${this.formatDate(value.end, 'L')}`);
              break;

            case 'transactions.created_at':
              this.filter(field, `${this.formatDate(value.start, 'L')}-${this.formatDate(value.end, 'L')}`);
              break;

            case 'content.created_at':
              this.filter(field, `${this.formatDate(value.start, 'L')}-${this.formatDate(value.end, 'L')}`);
              break;

          }
        }
      },

      getDatePickerPlaceholder (isRange, isDateTime) {
        return isRange ? `MM/DD/YYYY ${isDateTime ? 'hh:mm' : ''}- MM/DD/YYYY ${isDateTime ? 'hh:mm' : ''}` : `MM/DD/YYYY ${isDateTime ? 'hh:mm' : ''}`
      }
    },
    watch: {
      loading(value) {
        this.loader = value
      },
      extended(val) {
        this.extend = val
      },
      filters(val) {
        this.filterObject = val;
      }
    }
  }

</script>
